//  ############################### New Code ###################################
/* eslint-disable */
import React from 'react';
import { ButtonGroup, ToggleButton } from 'react-bootstrap';

const TabSwitcher = ({ selectedTab, setSelectedTab, tabs }) => {
  return (
    // <ButtonGroup className="mb-4 shadow-sm">
    <ButtonGroup className="mb-2 shadow-sm gap-2">
      {tabs.map((tab, idx) => (
        <ToggleButton
          key={idx}
          id={`tab-${idx}`}
          type="radio"
          variant={selectedTab === tab ? 'primary' : 'light'}
          name="tab"
          value={tab}
          checked={selectedTab === tab}
          onChange={(e) => setSelectedTab(e.currentTarget.value)}
        >
          {tab}
        </ToggleButton>
      ))}
    </ButtonGroup>
  );
};

export default TabSwitcher;
